import { Nullable } from 'legacy/lut/classes/models/utils'

import { getUrlParam } from 'core-components/helpers/url'

export const getUrlSummary = (): Nullable<string> => {
  const urlSummary = getUrlParam('summary')
  return urlSummary ?? null
}
